import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPatch } from './axiosUtils';
import './axiosInterceptor';

const AcknowledgementService = {
  async acknowledge(userId: string, payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPatch(`participant/acknowledge/${userId}`, payload);
  },
};
export default AcknowledgementService;
